import { render, staticRenderFns } from "./CalendarScrollButton.vue?vue&type=template&id=64a31c93&"
import script from "./CalendarScrollButton.vue?vue&type=script&lang=ts&"
export * from "./CalendarScrollButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports